<template>
    <teleport to="#navigationSpot">
        <nav v-if="company">
            <a :href="ambassador_url" target="_blank" class="more">
                <span class="title">{{ trans("Start aanvraag")}}</span>
            </a>
        </nav>
    </teleport>
</template>

<script>
import {defineComponent, inject, computed } from "vue";
import {useRoute} from "vue-router";

import Icon from "components/icon";
import trans from "helpers/_translation";

import { value } from "store/portal";
import { company } from "store/company";

export default defineComponent({
    name: "part",
    components: {
        Icon
    },
    setup() {
        const route = useRoute();
        const url = computed(() => {
            return trans(`https://aanvraag.jobse.nl/?referralid=%s`, value(company.value, "ambassadeurs_commissie_referralid"));
        });
        const ambassador_url = computed(() => {
            return `${url.value}&ambassadeur`;
        });



        return {
            trans,
            route,

            company,

            url,
            ambassador_url
        }
    }
});
</script>